import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Phases_getInstance153dg9ipormlv as Phases_getInstance } from '../../request/HttpRequestPipeline.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  Sender4pyqqer9k7up as Sender,
  Plugin_getInstance326p2fy5fh97r as Plugin_getInstance,
} from '../HttpSend.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../../request/HttpRequest.mjs';
import { plugin3vxt624hnu3pv as plugin } from '../HttpClientPlugin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$intercept, it, $completion) {
  var tmp = $this.j5u_1($this$intercept.b4r_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var SetupRequest$install$slambdaClass;
function SetupRequest$install$slambda() {
  if (SetupRequest$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.j5u_1 = $handler;
      }
      m5g($this$intercept, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$intercept, it), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.m5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    SetupRequest$install$slambdaClass = $;
  }
  return SetupRequest$install$slambdaClass;
}
function SetupRequest$install$slambda_0($handler) {
  var i = new (SetupRequest$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.m5g($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var SetupRequestClass;
function SetupRequest() {
  if (SetupRequestClass === VOID) {
    class $ {
      k5u(client, handler) {
        var tmp = Phases_getInstance().a5m_1;
        client.p5f_1.f4r(tmp, SetupRequest$install$slambda_0(handler));
      }
      f5m(client, handler) {
        return this.k5u(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SetupRequest');
    SetupRequestClass = $;
  }
  return SetupRequestClass;
}
var SetupRequest_instance;
function SetupRequest_getInstance() {
  return SetupRequest_instance;
}
var SenderClass;
function Sender_0() {
  if (SenderClass === VOID) {
    class $ {
      constructor(httpSendSender, coroutineContext) {
        this.d5p_1 = httpSendSender;
        this.e5p_1 = coroutineContext;
      }
      ew() {
        return this.e5p_1;
      }
      f5p(requestBuilder, $completion) {
        return this.d5p_1.j5s(requestBuilder, $completion);
      }
    }
    initMetadataForClass($, 'Sender', VOID, VOID, [CoroutineScope()], [1]);
    SenderClass = $;
  }
  return SenderClass;
}
var Send$install$slambdaClass;
function Send$install$slambda() {
  if (Send$install$slambdaClass === VOID) {
    class $ {
      constructor($handler, $client) {
        this.l5u_1 = $handler;
        this.m5u_1 = $client;
      }
      n5u($this$intercept, request, $completion) {
        return this.l5u_1(new (Sender_0())($this$intercept, this.m5u_1.o5f_1), request, $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Sender()) : false) ? p1 : THROW_CCE();
        return this.n5u(tmp, p2 instanceof HttpRequestBuilder() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    Send$install$slambdaClass = $;
  }
  return Send$install$slambdaClass;
}
function Send$install$slambda_0($handler, $client) {
  var i = new (Send$install$slambda())($handler, $client);
  var l = ($this$intercept, request, $completion) => i.n5u($this$intercept, request, $completion);
  l.$arity = 2;
  return l;
}
var SendClass;
function Send() {
  if (SendClass === VOID) {
    class $ {
      o5u(client, handler) {
        var tmp = plugin(client, Plugin_getInstance());
        tmp.z5s(Send$install$slambda_0(handler, client));
      }
      f5m(client, handler) {
        return this.o5u(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Send');
    SendClass = $;
  }
  return SendClass;
}
var Send_instance;
function Send_getInstance() {
  return Send_instance;
}
//region block: init
SetupRequest_instance = new (SetupRequest())();
Send_instance = new (Send())();
//endregion
//region block: exports
export {
  Send_instance as Send_instance3smuuitxedznj,
  SetupRequest_instance as SetupRequest_instance7itfp4kmymbg,
  Sender_0 as Sender1wtdgti85uk42,
};
//endregion

//# sourceMappingURL=CommonHooks.mjs.map
